module.exports = __webpack_public_path__ + "4fa5c9885aac8a2ce02440316dbb16a4.png";